"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgGroupFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M30.55 16A15.28 15.28 0 0023 14v2a13.72 13.72 0 016 1.44V20h-2v2h4v-5.7zM3.05 17.45A13.8 13.8 0 019 16v-2a15.32 15.32 0 00-7.52 2l-.47.3V22h4v-2h-2zM16 18a3.32 3.32 0 002.46-.9 4.17 4.17 0 001-3.1c0-3.47-2.19-4-3.5-4a3.4 3.4 0 00-2.47.9 4.17 4.17 0 00-1 3.1c0 3.48 2.19 4 3.51 4zM23.49 12a3.34 3.34 0 002.51-.9A4.17 4.17 0 0027 8c0-3.47-2.19-4-3.49-4a3.37 3.37 0 00-2.51.9A4.17 4.17 0 0020 8c0 3.48 2.19 4 3.49 4zm-1-5.68a1.33 1.33 0 011-.32c.8 0 1.51.16 1.5 2a2.51 2.51 0 01-.43 1.69 1.38 1.38 0 01-1 .31c-.79 0-1.5-.15-1.5-2a2.4 2.4 0 01.38-1.68zM8.49 12a3.34 3.34 0 002.51-.9A4.17 4.17 0 0012 8c0-3.47-2.2-4-3.5-4a3.39 3.39 0 00-2.5.9A4.17 4.17 0 005 8c0 3.48 2.19 4 3.49 4zm-1-5.68a1.33 1.33 0 011-.32c.8 0 1.51.16 1.5 2a2.51 2.51 0 01-.43 1.69 1.38 1.38 0 01-1.05.31C7.71 10 7 9.85 7 8a2.4 2.4 0 01.44-1.68zM16 20a15.09 15.09 0 00-7.52 1.88l-.47.3V28H24v-5.81l-.47-.3A15.15 15.15 0 0016 20z" })));
}
exports.default = SvgGroupFilled;
//# sourceMappingURL=GroupFilled.js.map